import React from 'react';
import { useIntl } from 'react-intl-next';

import { Anchor, Text } from '@atlaskit/primitives/compiled';

import { i18n } from '../contentReportTableMacroI18n.ts';
import { buildCreatorProfileUrl } from '../contentReportTableUrlUtils.ts';

interface CreatorCellProps {
	accountId: string | null;
	displayName: string;
	canViewProfiles: boolean;
}

export const CreatorCell = ({ accountId, displayName, canViewProfiles }: CreatorCellProps) => {
	const { formatMessage } = useIntl();

	if (!accountId) {
		return <Text>{formatMessage(i18n.anonymous)}</Text>;
	}

	if (canViewProfiles) {
		return (
			<Anchor href={buildCreatorProfileUrl(accountId)} target="_blank" rel="noopener noreferrer">
				{displayName}
			</Anchor>
		);
	}

	return <span>{displayName}</span>;
};
